import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=8fecdfd4&scoped=true&"
import script from "./PostView.vue?vue&type=script&lang=js&"
export * from "./PostView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fecdfd4",
  null
  
)

export default component.exports